module.exports = __webpack_public_path__ + "6af31e501298e4500312576a543ffdff.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/stethescope.png
// module id = 2437
// module chunks = 0